import { useState, useRef } from "react"

export function useManagedConfirmation<Data, Ret>(): [
  (data: Data) => Promise<Ret>,
  { showDialog: boolean; onResolve(value: Ret): void; data?: Data },
] {
  const [showDialog, setShowDialog] = useState(false)
  const [dialogData, setDialogData] = useState<Data | undefined>(undefined)
  const promiseRef = useRef<IPromise<Ret>>()

  async function getConfirmation(data?: any) {
    promiseRef.current = getPromise()
    setShowDialog(true)
    setDialogData(data)
    promiseRef.current.promise.then(() => {
      setShowDialog(false)
    })
    return promiseRef.current.promise
  }

  interface IPromise<T> {
    promise: Promise<T>
    resolve(val: T): void
    reject(val: any): void
  }
  function getPromise<T>(): IPromise<T> {
    let resolve: any
    let reject: any
    const promise = new Promise<T>((...args) => {
      resolve = args[0]
      reject = args[1]
    })
    return { promise, resolve, reject }
  }
  function handleResolve(value: Ret) {
    if (promiseRef.current) {
      promiseRef.current.resolve(value)
    }
  }
  return [getConfirmation, { showDialog, onResolve: handleResolve, data: dialogData }]
}
